<app-modal [isOpen]="isOpen" [title]="title" (closed)="onClose()">
  @if (error) {
    <div class="error-message">
      {{ error }}
    </div>
  }
  <form (ngSubmit)="onSubmit()">
    @if (editingAsCommissioner) {
      <div class="form-group">
        <label for="name">League Name *</label>
        <input
          type="text"
          id="name"
          name="name"
          [(ngModel)]="league.name"
          required
          placeholder="Enter league name"
        />
      </div>

      <div class="form-group">
        <label for="max_teams">Max Teams *</label>
        <input
          type="number"
          id="max_teams"
          name="max_teams"
          [(ngModel)]="league.max_teams"
          required
          min="2"
          max="32"
          placeholder="Enter max teams"
        />
      </div>

      <div class="form-group">
        <label for="team_budget">Team Budget ($) *</label>
        <input
          type="number"
          id="team_budget"
          name="team_budget"
          [(ngModel)]="league.team_budget"
          required
          min="1"
          placeholder="Enter team budget"
        />
      </div>

      <div class="form-group">
        <label for="roster_size">Roster Size *</label>
        <input
          type="number"
          id="roster_size"
          name="roster_size"
          [(ngModel)]="league.roster_size"
          required
          min="1"
          max="50"
          placeholder="Enter roster size"
        />
      </div>

      <div class="form-group">
        <label for="draft_datetime">Draft Date & Time</label>
        <input
          type="datetime-local"
          id="draft_datetime"
          name="draft_datetime"
          [(ngModel)]="league.draft_datetime"
        />
      </div>
    }

    <div class="form-group">
      <label for="team_name">Your Team Name</label>
      <input
        type="text"
        id="team_name"
        name="team_name"
        [(ngModel)]="league.team_name"
        placeholder="Enter your team name (optional)"
      />
    </div>

    <div class="form-actions">
      <button type="submit" class="btn btn-primary">
        {{ submitLabel }}
      </button>
      <button type="button" class="btn btn-secondary" (click)="onClose()">
        Cancel
      </button>
    </div>
  </form>
</app-modal>
